import { ElementType } from 'react';
import { Button } from '@/components/Button/Button';

export default Button as ElementType;
